
import { FormFieldTypes } from "../../../../data/formFieldType";

export const CertificateCorporateListdata = {
  name: "AdditionalInfo",
  initialState: {
    CompanyName: '',
    CompanyUEN: null,
    TypeOfCompany: null,
  },
  formFields: [
    {
      id: "CompanyName",
      lable: "Company Name",
      Field_Name: "Company Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "CompanyName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "CompanyUEN",
      lable: "Company UEN",
      Field_Name: "Company UEN",
      fieldType: FormFieldTypes.INPUT,
      dataField: "CompanyUEN",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
    {
      id: "TypeOfCompany",
      lable: "Type of Company",
      Field_Name: "Type of Company",
      fieldType: FormFieldTypes.SELECT,
      dataField: "TypeOfCompany",
      fieldSetting: {
        placeholder: "",
        options: [
          { value: 1, label: "Local" },
          { value: 1, label: "Foreign" }
        ],
      },
      style: {
        containerCss: "col-lg-6 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: true,
  },
};
